import { Component, OnInit, Inject, Input, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { InteractionService } from '../../service/interaction/interaction.service';
import { CreateFeedbackMetadatRequest, UpdateFeedbackMetadataRequest } from '../../model/chat.model';
import { ChatService } from '../../service/chat-service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { finalize, Observable, take } from 'rxjs';
/**
 * LikeDislikeDialogComponent
 * 
 * A dialog component for collecting user feedback (like/dislike) with optional comments.
 * This component displays different options based on whether the user is providing
 * positive (like) or negative (dislike) feedback.
 */
@Component({
    selector: 'app-like-dislike-dialog',
    templateUrl: './like-dislike-dialog.component.html',
    styleUrl: './like-dislike-dialog.component.scss',
    standalone: false
})

export class LikeDislikeDialogComponent implements OnInit {
  radioOptions: Array<{ feedback_metadata_id: number; feedback_value: string }> = [];
  selectedOption: string;
  additionalInfo: string;
  dialogType: 'like' | 'dislike';
  showThankYou: boolean = false;
  showError: boolean = false;
  commentError: boolean = false;
  Onclose: boolean = false;
  isEditable = true;
  @Input() apiResponse: any;
  userId: number;
  count: number = 0;
  @ViewChild('alertTemplate') alertTemplate;
  isSubmit: boolean= false;
  isEvaluat: boolean = false;
  isAction: boolean = false;
  isPosSubmit: boolean = false;
  isLikeDialog: boolean = false;
  isReadOnly: boolean = false;

  /**
   * Constructor - Initializes the dialog component
   * 
   * @param dialogRef - Reference to the dialog instance for controlling dialog behavior
   * @param data - Injected data containing dialog configuration and existing feedback data
   * @param apiService - Service for fetching feedback options from API
   */
  constructor(
    public dialogRef: MatDialogRef<LikeDislikeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private readonly dialog: MatDialog,
    private apiService: InteractionService, public ChatService: ChatService, private readonly toastr: ToastrService
  ) {
    // Ensure dialogType is assigned from data
    this.dialogType = data.dialogType;
    this.isEditable = data.isEditable;
    this.isReadOnly = !!data.readOnly;
    this.prepopulateData(data.existingData, data.likedislike);
    this.apiResponse = data.apiResponse;
  }

  ngOnInit(): void {
    this.loadRadioOptions();
    this.userId = Number(sessionStorage.getItem('userId'));
  }

  /**
   * Prepopulates form fields with existing feedback data if available
   * 
   * @param existingData - Previously submitted feedback data
   * @param type - Type of feedback ('like' or 'dislike') to match against current dialog
   */
  prepopulateData(existingData: any, type: any) {
    if (existingData && type === this.dialogType) {
      this.selectedOption = existingData.selectedOption;
      this.additionalInfo = existingData.comments;
    }
  }
  showCustomAlert(title: string, message: string) {
    const dialogRef = this.dialog.open(this.alertTemplate, {
      width: '500px',
      data: { title, message }
    });
  }

  /**
   * Loads radio button options from API service based on dialog type
   * Subscribes to the data observable and filters options for positive or negative feedback
   * Sets appropriate error handling for API failures
   */
  loadRadioOptions(): void {

    if (this.dialogType === 'like') {
      this.isLikeDialog = true;
      this.apiService.data$.subscribe(data => {

        data = this.getPosNegValue(data, 'Positive');
        this.radioOptions = data;
        // this.selectedOption = this.radioOptions[0]; // Set default selection
      },
        error => {
          console.error('Error fetching like options:', error);
        }
      );
    } else if (this.dialogType === 'dislike') {
      this.isLikeDialog = false;
      this.apiService.data$.subscribe(data => {
        data = this.getPosNegValue(data, 'Negative');
        this.radioOptions = data;
        // this.selectedOption = this.radioOptions[0]; // Set default selection
      },
        error => {
          console.error('Error fetching dislike options:', error);
        }
      );
    }
  }

  /**
   * Filters feedback options based on feedback type (Positive/Negative)
   * 
   * @param arr - Array of feedback options from API
   * @param value - Filter value ('Positive' or 'Negative')
   * @returns Filtered array containing only options matching the specified feedback type
   */
  getPosNegValue(arr, value) {
    return arr.filter(item => item.feedback_type === value)
      .map(item => item);

  }

  /**
   * Handles dialog cancellation
   * Closes the dialog without submitting any data
   */
  onCancel(): void {
    //const resultData = false;
    if(this.isAction){
          this.dialogRef.close(true);

    }else{
    this.dialogRef.close();
    }
  }

  /**
   * Handles form submission with validation
   * Validates required fields and closes dialog with feedback data
   * 
   * Validation rules:
   * - selectedOption is required for both like and dislike
   * - additionalInfo (comments) is required for dislike feedback
   * 
   * @returns void - Sets error flags if validation fails, otherwise closes dialog with result
   */
  onAdditionalInfoChange(value: string): void {
  if (this.dialogType === 'dislike') {
    this.commentError = !(value && value.toString().trim().length > 0);
  }
}

  handleSpeechContent(content: string): void {
    if (!content) return;
    const existing = this.additionalInfo ? this.additionalInfo.trim() : '';
    this.additionalInfo = existing ? `${existing} ${content}` : content;
    this.commentError = false;
  }

  onSubmit(): void {
    if (this.isReadOnly) {
      return;
    }
    if(this.isSubmit){
      this.toastr.info('Your feedback has been captured succesfully.')
    }
    if (!this.selectedOption) {
      this.showError = true;
      return;
    }
    const isBlankComment = !this.additionalInfo || this.additionalInfo.toString().trim().length === 0;
    if (this.dialogType === 'dislike' && !this.additionalInfo) {
      this.commentError = true;
      return;
    }
    const result = {
      selectedOption: this.selectedOption,
      additionalInfo: this.additionalInfo,
      isSubmit: true
    };
    const likeDislikeObj = {
      like: 1,
      dislike: 0
    }

    const updatefeedbackrequest: UpdateFeedbackMetadataRequest = {
      feedback_id: String(this.selectedOption),
      comment: this.additionalInfo || "",
      given_by: this.userId.toString(),
      is_good: String(this.data.likeDislikeVal)

    }
    const likeDislikeVal = likeDislikeObj[this.data];
    if (this.data.isEditable) {
      this.updateFeedbackData(this.data.chat_conversation_id, updatefeedbackrequest, this.data.summaryType);
    } else {
      this.createFeedbackMetadata(result, this.data.likeDislikeVal, this.data.chat_conversation_id, this.data.summaryType)
    }
  }
  onNoClick(): void {
    this.Onclose = true;
    const result = {
      selectedOption: this.selectedOption,
      additionalInfo: this.additionalInfo
    };
    this.dialogRef.close(result);
  }
  updateFeedbackData(chat_conversation_id, request, summarType) {
    this.ChatService.updateFeedbackMetadata(chat_conversation_id, request, summarType).
      subscribe((data: any[]) => {
        const result = true;
        this.dialogRef.close(result)
      });
  }
  constructFeedbackRequest(val, chat_conversation_id, result, summaryType) {
    if (
      summaryType === 'TEXTSUMMARY' ||
      summaryType === 'summary' ||
      summaryType === 'FILESUMMARY'
    ) {
      return {
        is_good: val,
        document_summary_id: chat_conversation_id,
        feedback_id: result.selectedOption,
        comment: result.additionalInfo || "",
        given_by: this.userId.toString(),
        business_unit_code: sessionStorage.getItem('businessUnitCode'),
      };
    } else {
      return {
        is_good: val,
        chat_history_id: chat_conversation_id,
        feedback_id: result.selectedOption,
        comment: result.additionalInfo || "",
        given_by: this.userId.toString(),
        business_unit_code: sessionStorage.getItem('businessUnitCode'),
      };
    }
  }

  public createFeedbackMetadata( result: any, val: number, chat_conversation_id: string, summaryType: string) {
    /* Incase of Summary related, submit the feedback directly */
    if (summaryType === 'TEXTSUMMARY' || summaryType === 'summary' || summaryType === 'FILESUMMARY' || summaryType === 'summary qna' || summaryType === 'QNASUMMARY') {
      const feedbackRequest = this.constructFeedbackRequest(val, chat_conversation_id, result, summaryType);
      this.ChatService.createFeedbackMetadata(feedbackRequest, summaryType).pipe(take(1), finalize(() => {
        this.isPosSubmit = true;
      })
      ).subscribe(resp => {
          this.dialogRef.close(true);
      });
    } else { /** Chat conversation: check for negative feedback count and respective logic */
      this.count += 1;
      this.isAction = true;
      const feedbackRequest = this.constructFeedbackRequest(val, chat_conversation_id, result, summaryType);
      this.isEvaluat = true;
      const apiCall = (): Observable<any> =>
        this.ChatService.createFeedbackMetadata(feedbackRequest, summaryType);
      if (val === 1) {
        this.ChatService.createFeedbackMetadata(feedbackRequest, summaryType);
        this.dialogRef.close(true);
      }
      const maybeOpenRegenerateDialog = (res: any): any => {
        if (res?.show_evaluate_button) {
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '500px',
            data: { message: 'Do you want to regenerate the response?' }
          });

          dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
              this.apiService.triggerRegenerate(this.additionalInfo);
              this.dialogRef.close(result);
            } else {
              this.dialogRef.close(result);
            }
          });
          return true;
        }
      };

      if (this.count > 1) {
        apiCall().subscribe({
          next: (res) => {
            // If backend asks to show a button, handle it
            if (!maybeOpenRegenerateDialog(res)) {
              if (this.count === 2 && !res?.show_evaluate_button) {
                    this.isEvaluat = false;
                    this.dialogRef.close(true);
              } else {
                this.isEvaluat = false;
              }
            }
          },
          error: (err) => {
            this.toastr.error(err);
            this.dialogRef.close();
            this.isEvaluat = false;
          }
        });
      } else {
        apiCall().subscribe({
          next: (res) => {
            this.isEvaluat = false;
            if (val == 0) {
              if (res?.show_evaluate_button) {
                this.isSubmit = true;
              }
              if (this.count == 1 && !(res?.show_evaluate_button)) {
                this.showCustomAlert('Evaluation Result', res.message);
              }
              if (res?.show_evaluate_button) {
                const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                  data: { message: res.message }
                });
                dialogRef.afterClosed().subscribe((r) => {
                  if (r === true) {
                    this.apiService.triggerRegenerate(this.additionalInfo);
                    this.dialogRef.close(true);
                  }
                });
              }
            }
          },
          error: (err) => {
            this.toastr.error(err);
            this.dialogRef.close();
            this.isEvaluat = false;
          }
        });
      }
    }

}

}


